import React from 'react';

import classNames from 'classnames';
import Head from 'next/head';

import LanguageMessageStyles from './LanguageMessage.module.scss';

interface ILanguageMessage {
  data: {
    title: string;
    description: string;
  };
  variant?: string;
}

const LanguageMessage = ({ data: { title, description }, variant }: ILanguageMessage) => (
  <>
    <Head>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex" />
    </Head>
    <div
      className={classNames(LanguageMessageStyles.languageMessageWrapper, {
        [LanguageMessageStyles[`languageMessage_${variant}`]]: variant,
      })}
    >
      <h1>{title}</h1>
      <h2>{description}</h2>
    </div>
  </>
);
export default LanguageMessage;
